<style>
  .Special {
    background-color: #ff9595 !important;
  }

  .DeviceBazgasht {
    background-color: #fff895 !important;
  }

  .DeviceBazgashtAll {
    background-color: #ff9c95 !important;
  }
</style>
<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">گزارش عملکرد </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود (زمان ثبت نامه)</option>
            <option value="2">اعمال شود (زمان ثبت مشتری)</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input [(ngModel)]="Filter_customer" name="Filter_customer" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نوع نامه</label>
          <select class="custom-select" [(ngModel)]="LetterType_Filter">
            <option value="0">همه موارد</option>
            <option value="1">نامه وارده</option>
            <option value="2">نامه صادره</option>
            <option value="3">رسید امانت</option>
            <option value="4">رسید امانت</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">موضوع نامه</label>
          <app-SubjectLetterOption (OnBack_SubjectLetter_Action)="OnGet_SubjectLetter_Action($event)">

          </app-SubjectLetterOption>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="LetterNumber_Filter" name="LetterNumber_Filter" type="number" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام دستگاه</label>
          <input [(ngModel)]="DeviceName_Filter" name="DeviceName_Filter" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">جمع فاکتور : {{DataList_Sum|number}}</label>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تعداد : {{DataList_Count|number}} </label>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نامه</th>
              <th>نوع</th>
              <th>مشتری</th>
              <th>فاکتور</th>

              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer          
            | paginate
                  : {
                      id: 'DataList_FeildTable',
                      itemsPerPage: 10,
                      currentPage: page,
                      totalItems: (DataList_LetterRequestCustomer).length
                    }">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.rial|number}}</td>
              <td>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='رسید امانت'"
                  [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-edit"></i> مشاهده
                </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='نامه وارده'"
                  [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-edit"></i>
                  مشاهده </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='نامه صادره'"
                  [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-edit"></i> مشاهده
                </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='درخواست کالیبراسیون'"
                  [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-edit"></i>
                  مشاهده </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>

  </div>
</div>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>نامه</th>
      <th>نوع</th>
      <th>مشتری</th>
      <th>فاکتور (ريال)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_LetterRequestCustomer">
      <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
      <td>{{item.code}}</td>
      <td>{{item.letterType}}</td>
      <td>{{item.customer}}</td>
      <td>{{item.rial|number}}</td>
    </tr>
  </tbody>
</table>